export enum GSMServiceKind {
  HTZ = "HTZ",
  RLT = "RLT",
  UNDEFINED = "UNDEFINED",
  VBS = "VBS",
}

export const ServiceKindList: GSMServiceKind[] = [
  GSMServiceKind.HTZ,
  GSMServiceKind.RLT,
  GSMServiceKind.VBS,
];

export function parseServiceKind(str: string): GSMServiceKind | undefined {
  switch (str.toLowerCase()) {
    case "htz":
      return GSMServiceKind.HTZ;
    case "rlt":
      return GSMServiceKind.RLT;
    case "vbs":
      return GSMServiceKind.VBS;
    default:
      return GSMServiceKind.UNDEFINED;
  }
}
